import React from 'react'
import { Elements, CardElement, useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';

const CARD_ELEMENT_OPTIONS = {
    style: {
        // base: {
        //     color: '#32325d',
        //     fontSize: '16px',
        // },
        base: {
            color: '#32325d',
            // fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '14px',
            '::placeholder': {
                // color: '#aab7c4',
                color: '#8f969c',
                fontWeight : '400',
            },
        },
        invalid: {
            color: '#fa755a',
            iconColor: '#fa755a',
        },
    },
};

const CardInput = React.memo(() => {
    return (
        <>

            <CardElement />

            {/* <div className='row mx-0'>
                <div className='col-12 px-0'>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <label className='font-w600'>Card Number</label>
                            <div style={{ padding: '10px', border: '2px solid rgba(107, 107, 107, 0.12)', borderRadius: '6px' }}>
                                <CardNumberElement options={CARD_ELEMENT_OPTIONS} />
                            </div>
                        </div>
                    </div>

                    <div className='row mx-0 mt-2'>
                        <div className='col-6 pe-2'>
                            <label className='font-w600'>Expiry Date</label>
                            <div style={{ padding: '10px', border: '2px solid rgba(107, 107, 107, 0.12)', borderRadius: '6px' }}>
                                <CardExpiryElement options={CARD_ELEMENT_OPTIONS} />
                            </div>
                        </div>

                        <div className='col-6 ps-2'>
                            <label className='font-w600'>Expiry Date</label>
                            <div style={{ padding: '10px', border: '2px solid rgba(107, 107, 107, 0.12)', borderRadius: '6px' }}>
                                <CardCvcElement options={CARD_ELEMENT_OPTIONS} />
                            </div>
                        </div>
                    </div>

                </div>
            </div> */}
        </>
    )
})

export default CardInput

const CardNumberInput = React.memo(({ onChange }) => {
    return (
        <CardNumberElement options={CARD_ELEMENT_OPTIONS} onChange={onChange} />
    )
});

const CardExpiryInput = React.memo(({ onChange }) => {
    return (
        <CardExpiryElement options={CARD_ELEMENT_OPTIONS} onChange={onChange} />
    )
});

const CardCvcInput = React.memo(({ onChange }) => {
    return (
        <CardCvcElement options={CARD_ELEMENT_OPTIONS} onChange={onChange} />
    )
});

export { CardNumberInput, CardExpiryInput, CardCvcInput };

